module.exports = __webpack_public_path__ + "img/fruit-mandarins-350x184.900290b1.jpg";